import React from 'react';
import './SaleOrderProgressBar.scss';

export enum SaleOrderProgressStep {
  SELECT_FUEL,
  SELECT_TRANSPORT,
  CONFIRM
}

export interface SaleOrderProgressBarProps {
  activeStep: SaleOrderProgressStep;
}

export default function SaleOrderProgressBar(props: SaleOrderProgressBarProps) {

  return (
    <div className='d-flex mb-3'>
      <span className={'progress-bar-step' + (props.activeStep === SaleOrderProgressStep.SELECT_TRANSPORT ? ' active' : '')}>
        1. Vali transport
      </span>      
      <span className={'progress-bar-step' + (props.activeStep === SaleOrderProgressStep.SELECT_FUEL ? ' active' : '')}>
        2. Vali kütus
      </span>
      <span className={'progress-bar-step' + (props.activeStep === SaleOrderProgressStep.CONFIRM ? ' active' : '')}>
        3. Kinnita
      </span>
    </div>
  )
}